export enum MembersEditMode {
  New,
  Invitation,
  Edit,
  InvitationCs,
  EditCs,
}

export enum ProfileMode {
  New,
  Edit,
  View,
  Edit_iOS,
}

export enum MembersViewMode {
  New,
  Edit,
  EditCs,
  View,
  EditBlocks,
}

export enum MemberRole {
  Owner = "owner",
  Member = "member",
  Guest = "guest",
  Anonymous = "anonymous",
}

export enum InviteApprovalType {
  Owner = "owner",
  None = "none",
}

export enum NotificationRange {
  All = "all",
  Mention = "mention",
  None = "none",
}

export enum JoinStatus {
  WaitApproval = "wait_approval",
  WaitJoin = "wait_join",
  Joined = "joined",
  Blocked = "blocked",
}
